module.exports = __webpack_public_path__ + "static/impact-of-the-coronavirus-c0682a3b1d6a8a08b093cda4f0de2da2.jpg";